var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRpaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rpa-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Extra-Large-Copy",
    transform: "translate(-45, -486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bot-svgrepo-com",
    transform: "translate(54, 495)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 4.48888889,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 0,
    y: 17.7777778,
    width: 40,
    height: 22.2222222,
    rx: 4.48888889
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 4.48888889,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 20,
    cy: 4.44444444,
    r: 4.44444444
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 8.88888889,
    x2: 20,
    y2: 17.7777778,
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 4.48888889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 11.1111111,
    cy: 26.6666667,
    r: 2.22222222
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 28.8888889,
    cy: 26.6666667,
    r: 2.22222222
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpaIcon);
export default __webpack_public_path__ + "static/media/rpa-icon.cc2d3a715653e1c4bb6a544517200c2e.svg";
export { ForwardRef as ReactComponent };